<template>
  <div class="dial-table-container">
    <!-- Left-table class changed to smmt-table  -->
    <div class="smmt-table" v-if="dialInfo.original">
      <div v-if="dialInfo.modified.label" class="table-header">{{ dialInfo.original.label }}</div>
      <!-- Left-table-container class changed to table-container -->
      <div class="table-container">
        <div class="row" v-for="(row, index) in dialInfo.original.data" :key="`row-${index}`">
          <div v-if="row.label && row.labelName !== 'Dial Title'" class="header">{{ row.label }}</div>
          <div class="data" v-if="row.label">{{ row.value }}<span v-if="row.format === '#.0%'">%</span></div>
        </div>
        <!-- modified-row class required -->
      </div>
      <div
        class="modified-row"
        v-if="
          dialInfo.modified &&
          dialInfo.modified.data &&
          dialInfo.modified.data.length > 0 &&
          dialInfo.properties.modified !== 'N'
        "
      >
        <div class="row" v-for="(row, index) in dialInfo.modified.data" :key="`row-1${index}`">
          <div class="modified-data" v-if="row.valueName">
            {{ row.value }}<span v-if="row.format === '#.0%'">%</span>
          </div>
        </div>
      </div>
    </div>
    <p v-if="dialInfo.detailsSectionTitle" class="section-title">{{ dialInfo.detailsSectionTitle }}</p>
    <div v-if="dialInfo.detailsSectionTitle" class="row-2 flex-row">
      <div class="left-table" v-if="dialInfo.firstDetailSection">
        <div class="left-table-container">
          <div v-for="(row, rowIndex) in dialInfo.firstDetailSection" :key="`row-${rowIndex}`">
            <div v-if="row.label" class="row">
              <div class="header" v-if="row.label">{{ row.label }}</div>
              <div class="data" v-for="(data, index) in row.data" :key="`data-${index}`">
                <div>{{ data.data }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SMMT',
  components: {},
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.dial-table-container {
  margin-top: 28px;
  display: flex;
  flex-direction: column;

  .smmt-table {
    display: flex;
    margin-right: 40px;
    flex-direction: column !important;
    .table-header {
      min-height: 30px;
    }
    .table-container {
      display: flex;
      .row {
        display: flex;
        flex-direction: column;
        .header {
          background-color: #898c8d;
          color: white;
          padding: 12px 10px;
          font-size: 14px;
          min-height: 18px;
          min-width: 35px;
        }
        .data {
          color: #1d1d1b;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          height: 50px;
        }
        .data:nth-child(odd) {
          background: #f9f9f9;
        }
        .total-row {
          background: white !important;
          font-weight: 600;
        }
      }
    }
  }
}
.section-title {
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
  color: $primary;
  text-transform: uppercase;
  text-align: left;
  margin: 40px 0px;
}
.modified-row {
  display: flex;
}
.modified-data {
  color: #1d1d1b;
  font-size: 14px;
  padding: 10px 0px;
  text-align: center;
  width: 78px;
}
.header {
  text-align: center;
}
</style>
